<template>
  <div class="column_public">
    <div class="public-main-info-wrapper">
      <MainInfoOfPublicTender />
      <ConfirmDeclineOfPublicTender v-if="contractorName" :contractor-name="contractorName" />
    </div>
    <div class="tabs w-tabs">
      <div class="tabs-menu w-tab-menu">
        <PublicTenderTabButton
          v-for="tab in tabs"
          :key="tab.id"
          :text="tab.text"
          :selected="currentTab === tab.id"
          @click.native="currentTab = tab.id"
        />
      </div>
      <div class="w-tab-content">
        <DescriptionTabOfPublicTender v-if="currentTab === 1" />
        <ContactTabOfPublicTender v-if="currentTab === 2" />
        <FilesTabOfPublicTender v-if="currentTab === 3" />
      </div>
    </div>
    <DescriptionOfPublicTender />
    <SendOfferOfPublicTender />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import PublicTenderTabButton from '@/containers/public-tender/tabs/PublicTenderTabButton';
  import ContactTabOfPublicTender from '@/containers/public-tender/tabs/ContactTabOfPublicTender';
  import FilesTabOfPublicTender from '@/containers/public-tender/tabs/FilesTabOfPublicTender';
  import DescriptionTabOfPublicTender from '@/containers/public-tender/tabs/DescriptionTabOfPublicTender';
  import MainInfoOfPublicTender from '@/containers/public-tender/main-column/MainInfoOfPublicTender';
  import DescriptionOfPublicTender from '@/containers/public-tender/main-column/DescriptionOfPublicTender';
  import SendOfferOfPublicTender from '@/containers/public-tender/main-column/send-offer/SendOfferOfPublicTender';
  import ConfirmDeclineOfPublicTender from '@/containers/public-tender/main-column/ConfirmDeclineOfPublicTender';

  export default {
    name: 'MainColumnOfPublicTender',
    components: {
      SendOfferOfPublicTender,
      DescriptionOfPublicTender,
      MainInfoOfPublicTender,
      DescriptionTabOfPublicTender,
      FilesTabOfPublicTender,
      ContactTabOfPublicTender,
      PublicTenderTabButton,
      ConfirmDeclineOfPublicTender,
    },
    data() {
      return {
        currentTab: 1,
      };
    },
    computed: {
      ...mapState('publicTender', ['publicTenderInfo']),
      contractorName() {
        return this.publicTenderInfo?.offer?.contractor_team?.name;
      },
      tabs() {
        let baseTabs = [
          { id: 3, text: this.$t('Files') },
          { id: 2, text: this.$t('Contacts') },
        ];
        if (this.publicTenderInfo.description) {
          baseTabs = [{ id: 1, text: this.$t('Details') }, ...baseTabs];
        }
        return baseTabs;
      },
    },
    created() {
      this.currentTab = this.tabs[0].id;
    },
  };
</script>
<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
